// userRoleUtil.js

import { safeGetItem, safeSetItem, safeRemoveItem } from './safeStorage';

/**
 * Retrieves the user role from localStorage.
 * @returns {string|null} user role (e.g. "admin", "Checker", "Maker".) or null if not found
 */
export const getUserRole = () => {
  try {
    const role = localStorage.getItem('design')
    return role || null
  } catch (err) {
    console.error("Failed to parse user data from localStorage:", err)
    return null
  }
}

/**
 * Stores the user role in localStorage (within a user object).
 * Accepts additional user fields if needed (e.g. username, token).
 * @param {Object} userData 
 */
export const setUserData = (userData) => {
  try {
    // Merge existing user data with new data, or overwrite as needed
    const existingData = safeGetItem('user', {});
    const updatedData = { ...existingData, ...userData };

    // Use safe storage to prevent object storage issues
    const success = safeSetItem('user', updatedData);
    if (!success) {
      console.error('Failed to store user data safely');
    }
  } catch (err) {
    console.error("Failed to store user data in localStorage:", err)
  }
}

/**
 * Clears the user data from localStorage.
 */
export const clearUserData = () => {
  safeRemoveItem('user');
}
